import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom'; // <-- Added useLocation
import ContactBtn from '../ContactBtn/ContactBtn';
import styles from './Navbar.module.css';
import logo from '../../assets/FasBeam.svg';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    const [isVisible, setIsVisible] = useState(true);

    const prevScrollY = useRef(0);
    const isMenuOpenRef = useRef(false); // Ref used to bypass stale-state inside the scroll listener
    const location = useLocation();

    // Keep the Ref in sync with the State
    useEffect(() => {
        isMenuOpenRef.current = isMenuOpen;
    }, [isMenuOpen]);

    // FIX 1: Automatically snap menu shut the moment the URL changes
    useEffect(() => {
        setIsMenuOpen(false);
    }, [location.pathname]);

    // FIX 2: Freeze the background webpage from scrolling when the Mobile Drawer is open
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMenuOpen]);

    useEffect(() => {
        const handleScroll = () => {
            // FIX 3: If the drawer is open, completely paralyze the hide/reveal header logic
            if (isMenuOpenRef.current) return;

            const currentScrollY = window.scrollY;

            setIsSticky(currentScrollY > 80);

            if (currentScrollY < 40) {
                setIsVisible(true);
            } else if (currentScrollY > prevScrollY.current) {
                setIsVisible(false);
            } else {
                setIsVisible(true);
            }

            prevScrollY.current = currentScrollY;
        };

        const handleNavClick = (e) => {
            const target = e.target.closest('a');
            if (target && target.getAttribute('href')?.startsWith('#')) {
                e.preventDefault();
                const id = target.getAttribute('href').slice(1);
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                    setIsMenuOpen(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        document.addEventListener('click', handleNavClick);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.removeEventListener('click', handleNavClick);
        };
    }, []);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    return (
        <nav className={`${styles.navbar} ${isSticky ? styles.sticky : ''} ${isVisible ? '' : styles.hidden}`}>
            <NavLink to="/" className={styles.logo} onClick={closeMenu}>
                <img src={logo} alt="FasBeam Logo" />
            </NavLink>

            <div className={`${styles.navContainer} ${isMenuOpen ? styles.active : ''}`}>
                {/* FIX 4: Event bubbling catches any clicked link inside this UL */}
                <ul className={styles.navlist} onClick={closeMenu}>
                    <li>
                        <NavLink to="/" className={({ isActive }) => isActive ? styles.activeLink : ''}>
                            Home
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/socials" className={({ isActive }) => isActive ? styles.activeLink : ''}>
                            Socials
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/consultancy" className={({ isActive }) => isActive ? styles.activeLink : ''}>
                            Consultancy
                        </NavLink>
                    </li>
                </ul>

                <div className={styles.actionGroup}>
                    <div className={styles.ContactBtnWrapper} onClick={closeMenu}>
                        <ContactBtn />
                    </div>
                </div>

                <div className={styles.cancelBtn} onClick={toggleMenu}>
                    <FontAwesomeIcon icon={faXmark} />
                </div>
            </div>

            <div className={styles.menuBtn} onClick={toggleMenu}>
                <FontAwesomeIcon icon={faBars} />
            </div>
        </nav>
    );
};

export default Navbar;